import { Pipe, PipeTransform } from '@angular/core';
import { BackResourceService } from "../services/back-resource.service";

@Pipe({
    name: 'backResource',
    standalone: false
})
export class BackResourcePipe implements PipeTransform {

  constructor(private backResource: BackResourceService) {

  }

  transform(resource: any): string {
    return this.backResource.getUrl(resource);
  }

}
